import React from 'react'

import ErrorCard from '../../components/ErrorCard'
import SceneLayout from '../../components/SceneLayout'

const errorSceneContent = errorCode => {
  switch (errorCode) {
    case 404:
      return {
        image: '404-sheep.png',
        altText: errorCode.toString(),
        heading: 'meh',
        subheading: "We can't seem to find the page you're looking for.",
        cta: {
          label: 'Back home',
          href: '/',
        },
      }

    default:
      return {
        image: 'grumpy-cat-sitting.svg',
        heading: 'Something went wrong. How awful.',
        cta: {
          label: 'Refresh page',
          href: window.location.pathname,
        },
      }
  }
}

/**
 * ErrorScene component
 *
 * @param {Object} props
 * @param {number} [props.errorCode]
 *
 * @returns {JSX.Element}
 */
const ErrorScene = ({ errorCode }) => {
  const { image, altText, heading, subheading, cta } = errorSceneContent(errorCode)

  return (
    <SceneLayout>
      <ErrorCard image={image} altText={altText} heading={heading} subheading={subheading} cta={cta} />
    </SceneLayout>
  )
}

export default ErrorScene
